import LanguageSwitcher from './LanguageSwitcher';
import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
interface HeaderProps {
	steps: { icon: JSX.Element; text: string }[];
	activeStep: number;
	isActive?: boolean;
}
function Header({ steps, activeStep }: HeaderProps) {
	const { t } = useTranslation();
	const renderWizardItem = (activeStep: number) =>
		steps.map((step, index) => (
			<div key={index} className='header__stepper__progress__item'>
				<div
					className={classNames('header__stepper__progress__item__icon', {
						'header__stepper__progress__item__icon--active':
							index + 1 === activeStep,
					})}
				>
					{step.icon}
				</div>
				<div
					className={classNames(
						'header__stepper__progress__item__title d-md-none d-xl-block',
						{
							'header__stepper__progress__item__title--active':
								index + 1 === activeStep,
						}
					)}
				>
					{t(step.text)}
				</div>
			</div>
		));

	return (
		<header className='header'>
			<div className='container'>
				<LanguageSwitcher />
				<div className='header__stepper'>
					<div className='header__stepper__progress d-none d-md-flex'>
						{renderWizardItem(activeStep)}
					</div>
					<div className='header__title d-md-none'>
						<div className='header__title__step-icon'>
							{steps[activeStep - 1].icon}
						</div>
						<div className='header__title__step-text'>
							{t(steps[activeStep - 1].text)}
						</div>
					</div>
					<div className='header__step-counter d-md-none'>
						{t('common.step.of', {
							currentStep: activeStep,
							totalSteps: steps.length,
						})}
					</div>
				</div>
			</div>
		</header>
	);
}

export default Header;
